import SITE from '@/config/site'

interface JSONLDSchema {
  '@context': string
  '@type': string
  [key: string]: unknown
}

interface SchemaProps {
  schema: JSONLDSchema
}

export function Schema({ schema }: SchemaProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  )
}

export const schemas = {
  person: {
    '@context': 'https://schema.org',
    '@type': 'Person',
    name: 'Fernando A.O.Borges',
    url: SITE.url(SITE.paths.home),
    jobTitle: 'React Native Developer',
    description: SITE.organization.description,
    image: SITE.url('/profile.webp'),
    sameAs: [SITE.social.github, SITE.social.linkedin],
  },

  software: (name: string, description: string, url: string) => ({
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name,
    description,
    url,
    applicationCategory: 'MobileApplication',
    offers: {
      '@type': 'Offer',
      priceCurrency: 'BRL',
      price: '0',
    },
  }),

  breadcrumb: (items: Array<{ name: string; url: string }>) => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  }),

  organization: {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Fernando A.O.Borges',
    url: SITE.url(SITE.paths.home),
    logo: SITE.url(SITE.organization.logo),
    description: SITE.organization.description,
    sameAs: [SITE.social.github, SITE.social.linkedin],
  },
}
